import {initBeelinePhonesEffects} from "../components/phones-effects";

export function initBeelineLanding() {
    if (!$('#beeline_landing').length) return;

    initBeelinePhonesEffects();
}
